import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DownOutlined } from '@ant-design/icons';
import './accordion.scss';

const Accordion = ({ title, children, defaultExpanded }) => {
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);
    const [contentHeight, setContentHeight] = useState(0);
    const contentRef = useRef(null);

    useEffect(() => {
        if (contentRef.current) {
            setContentHeight(contentRef.current.scrollHeight);
        }
    }, [children]);

    const toggleAccordion = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div className={`accordion ${isExpanded ? 'accordion--expanded' : ''}`}>
            <button
                type="button"
                className="accordion__header"
                onClick={toggleAccordion}
                aria-expanded={isExpanded}>
                <span className="accordion__title">{title}</span>
                <span className={`accordion__chevron ${isExpanded ? 'accordion__chevron--rotated' : ''}`}>
                    <DownOutlined />
                </span>
            </button>
            <div
                className="accordion__content-wrapper"
                style={{ height: isExpanded ? contentHeight : 0 }}>
                <div ref={contentRef} className="accordion__content">
                    {children}
                </div>
            </div>
        </div>
    );
};

Accordion.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    defaultExpanded: PropTypes.bool,
};

Accordion.defaultProps = {
    defaultExpanded: false,
};

export default Accordion;
